export default __webpack_public_path__ + "static/media/noypi-oyat-banner.4aa73001.png";